import { MenuRutas , GetHeaderRequest, GetResponseBody } from './RutasConfig.jsx';
import axios from 'axios';

//////////////Menu ///////////////
export const Obtener_Menu_Request = async (pToken,ModuloID) => {
    const data ={ModuloID}
    const result = await axios.post(MenuRutas.Obtener_Menu,JSON.stringify(data),{headers: GetHeaderRequest(pToken)});
    return await GetResponseBody(result);
}


export const Obtener_MenuOpciones_Request = async (pToken,ModuloID,Menu_Id) => {
    const data ={ModuloID, Menu_Id}
    const result = await axios.post(MenuRutas.Obtener_MenuOpciones,JSON.stringify(data),{headers: GetHeaderRequest(pToken)});
    return await GetResponseBody(result);
}

/////////////Menu opciones ///////////

export const Obtener_MenuOpciones_Lista_Request = async (pToken, pModulo, pUsuarioId, pMenuId) => {
    const data = { pModulo, pUsuarioId, pMenuId }
    const result = await axios.post(MenuRutas.SegMenuOpciones_Lista, JSON.stringify(data), { headers: GetHeaderRequest(pToken) });
    return await GetResponseBody(result);
}

export const Obtener_MenuNombre_Request = async (pToken, pModulo, pMenuNombre) => {
    const data = { pModulo, pMenuNombre }
    const result = await axios.post(MenuRutas.Obtener_MenuNombre, JSON.stringify(data), { headers: GetHeaderRequest(pToken) });
    return await GetResponseBody(result);
}

//////////////Validaciones///////////

export const Seg_Usuario_Validar_Opcion_Request = async (pToken,ModuloID,Menu_Id) => {
    const data ={ModuloID, Menu_Id}
    const result = await axios.get(MenuRutas.Seg_Usuario_Validar_Opcion,JSON.stringify(data),{headers: GetHeaderRequest(pToken)});
    return await GetResponseBody(result);
}

export const menu_Validar_Opcion_Request = async (pToken,pEmpresa,pMenuId, pOpcionId, pLogin, pPassword, pDesc, pTipoDoc, pDoc, pPantalla,pModuloId) => {
    const data ={pEmpresa,pMenuId, pOpcionId, pLogin, pPassword, pDesc, pTipoDoc, pDoc, pPantalla,pModuloId}
    const result = await axios.post(MenuRutas.Menu_Validar_Opcion,JSON.stringify(data),{headers: GetHeaderRequest(pToken)});
    return await GetResponseBody(result);
}
